import { render, staticRenderFns } from "./ChartUnavailable.vue?vue&type=template&id=72179c0f"
import script from "./ChartUnavailable.vue?vue&type=script&lang=js"
export * from "./ChartUnavailable.vue?vue&type=script&lang=js"
import style0 from "./ChartUnavailable.vue?vue&type=style&index=0&id=72179c0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports